// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bread-crumbs_wrapper__7tjvc","container":"bread-crumbs_container__okR1Q","breadCrumbs":"bread-crumbs_breadCrumbs__piMpp"};